'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));

    // Override from plugin_wishlists wishlist functionality on PDP (not product tile which uses wishlistHeart)
    processInclude(require('./product/wishlist'));
    processInclude(require('wishlist/product/wishlistHeart'));
});
